import "./index.scss";
import React, { useEffect, useState } from "react"
import { useNavigate, NavLink, useLocation } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { logout, setLoginShow } from "../../redux/modules/user/action.js"
import { Avatar, Badge, Popover, Button, message, Flex, Divider, Drawer } from 'antd'
import { UserOutlined, UserSwitchOutlined, LogoutOutlined, HeartOutlined, TeamOutlined, MenuOutlined, SearchOutlined, AppstoreOutlined, HistoryOutlined, InfoCircleOutlined } from "@ant-design/icons"
import logo from "../../images/Logo.png"
import Search from "../components/Search"
import ImageLoad from "@/components/ImageLoad"

const Header = () => {
  const location = useLocation()
  const user = useSelector((state) => state.user)
  const notifications = useSelector((state) => state.user.notifications)
  const [unreadCount, setUnreadCount] = useState(0)
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  let handleLogout = () => {
    dispatch(logout())
    navigate('/')
    message.error("退出成功")
    setMobileDrawerVisible(false)
  };

  const handleMobileMenuClick = (path) => {
    navigate(path)
    setMobileDrawerVisible(false)
  }

  const handleSearchClick = () => {
    navigate('/search')
  }

  useEffect(() => {
    if (notifications && notifications.length > 0) {
      setUnreadCount(notifications.filter((item) => item.isRead === 0).length)
    }
  }, [notifications])

  const UserInfo = () => {
    const userId = user?.userInfo?.userId || user?.userInfo?.id || 'demo'
    const nickname = (user && user.userInfo) ? user.userInfo.nickname : '匿名'
    const followsCount = user && user.follows ? user.follows.length : 0
    const fansCount = user && user.fans ? user.fans.length : 0

    return (
      <div className="user-popover-content">
        {/* 用户信息区域 */}
        <div className="user-info-header">
          <div className="user-name">{nickname}</div>
          <Flex gap={16} className="user-stats">
            <div className="stat-item">
              <HeartOutlined className="stat-icon" />
              <span className="stat-label">关注</span>
              <span className="stat-value">{followsCount}</span>
            </div>
            <div className="stat-item">
              <TeamOutlined className="stat-icon" />
              <span className="stat-label">粉丝</span>
              <span className="stat-value">{fansCount}</span>
            </div>
          </Flex>
        </div>

        <Divider style={{ margin: '4px 0', borderColor: 'rgba(102, 126, 234, 0.15)' }} />

        {/* 操作按钮区域 */}
        <div className="user-actions">
          <Button
            type="text"
            icon={<UserSwitchOutlined />}
            onClick={() => navigate(`/user/overview/${userId}`)}
            className="action-btn"
          >
            个人中心
          </Button>
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            className="action-btn action-btn-danger"
          >
            退出登录
          </Button>
        </div>
      </div>
    );
  };

  const userId = user?.userInfo?.userId || user?.userInfo?.id || 'demo'
  const nickname = (user && user.userInfo) ? user.userInfo.nickname : '匿名'

  // Drawer内容
  const drawerContent = (
    <div className="mobile-drawer-content">
      {user.isLogin ? (
        <>
          {/* 用户信息头部 */}
          <div className="mobile-drawer-header">
            {user && user.userInfo && user.userInfo.avatar ? (
              <div className="mobile-user-avatar">
                <ImageLoad url={user.userInfo.avatar} />
              </div>
            ) : (
              <Avatar size={48} icon={<UserOutlined />} />
            )}
            <div className="mobile-user-name">{nickname}</div>
          </div>
          <Divider style={{ margin: '12px 0' }} />
          {/* 菜单项 */}
          <div className="mobile-drawer-menu">
            <div 
              className="mobile-menu-item"
              onClick={() => handleMobileMenuClick('/user/model')}
            >
              <AppstoreOutlined className="mobile-menu-item-icon" />
              <span>我的模型</span>
            </div>
            <div 
              className="mobile-menu-item"
              onClick={() => handleMobileMenuClick('/user/collect')}
            >
              <HeartOutlined className="mobile-menu-item-icon" />
              <span>我的收藏</span>
            </div>
            <div 
              className="mobile-menu-item"
              onClick={() => handleMobileMenuClick('/user/history')}
            >
              <HistoryOutlined className="mobile-menu-item-icon" />
              <span>浏览历史</span>
            </div>
            <div 
              className="mobile-menu-item"
              onClick={() => handleMobileMenuClick(`/user/overview/${userId}`)}
            >
              <UserSwitchOutlined className="mobile-menu-item-icon" />
              <span>个人中心</span>
            </div>
            <div 
              className="mobile-menu-item"
              onClick={() => handleMobileMenuClick('/aboutUs')}
            >
              <InfoCircleOutlined className="mobile-menu-item-icon" />
              <span>关于我们</span>
            </div>
            <Divider style={{ margin: '8px 0' }} />
            <div 
              className="mobile-menu-item mobile-menu-item-danger"
              onClick={handleLogout}
            >
              <LogoutOutlined className="mobile-menu-item-icon" />
              <span>退出登录</span>
            </div>
          </div>
        </>
      ) : (
        <div className="mobile-drawer-login">
          <Button 
            type="primary" 
            block 
            size="large"
            onClick={() => {
              dispatch(setLoginShow(true))
              setMobileDrawerVisible(false)
            }}
          >
            登录/注册
          </Button>
        </div>
      )}
    </div>
  )

  return (
    <div
      className="header"
      style={{ background: location.pathname === "/" ? "rgba(251, 251, 253, 0.8)" : "rgba(255, 255, 255, 0.8)" }}
    >
      <div className="head_content">
        <div className="left-menu flex align-center">
          <NavLink
            className="flex align-center"
            to="/"
          >
            <img src={logo} className="logo" alt="logo" />
            <h3>MetaHub</h3>
          </NavLink>
          <div className="menu_item">
            <NavLink to="/category" id="model-category">模型分类</NavLink>
            <NavLink to="/aboutUs" id="about-us" className="about-us-link">关于我们</NavLink>
          </div>
        </div>
        <div className="search">
          <Search hotList={[]} />
        </div>
        {/* 手机端搜索图标 */}
        <div className="mobile-search-icon" onClick={handleSearchClick}>
          <SearchOutlined />
        </div>
        {/* 手机端汉堡菜单 */}
        <div className="mobile-menu-icon" onClick={() => setMobileDrawerVisible(true)}>
          <MenuOutlined />
        </div>
        <div className="right_menu flex align-center">
          {user.isLogin ? (
            <>
              <NavLink className="its" id="my-model" to="/user/model">
                我的模型
              </NavLink>
              <NavLink className="its" to="/user/collect">
                我的收藏
              </NavLink>
              <NavLink className="its" to="/user/history">
                浏览历史
              </NavLink>
              <Popover
                content={<UserInfo />}
                trigger="hover"
                overlayClassName="user-popover-overlay"
                placement="bottomRight"
                overlayInnerStyle={{
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}
              >
                <Badge count={ unreadCount }>
                  {user && user.userInfo && user.userInfo.avatar ? (
                    <div
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        overflow: "hidden",
                      }}
                    >
                      <ImageLoad url={user.userInfo.avatar} />
                    </div>
                  ) : (
                    <Avatar
                      icon={<UserOutlined />}
                    />
                  )}
                </Badge>
              </Popover>
            </>
          ) : (
            <>
              <span
                onClick={ () => dispatch(setLoginShow(true)) }
                className="register flex-ali"
              >
                登录/注册
              </span>
            </>
          )}
        </div>
      </div>
      {/* Drawer侧边栏 */}
      <Drawer
        title={null}
        placement="right"
        onClose={() => setMobileDrawerVisible(false)}
        open={mobileDrawerVisible}
        className="mobile-header-drawer"
        width={200}
        closable={false}
      >
        {drawerContent}
      </Drawer>
    </div>
  );
};

export default Header;
